import * as React from 'react';
import PropTypes from 'prop-types';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';

import useGlobalConfig from '../../hooks/globalConfig';

const {purchaseState } = useGlobalConfig()
const ArrayEstadosKeys = [Object.keys(purchaseState),Object.values(purchaseState) ]
function SimpleDialog(props) {
  const { onClose, selectedValue, open } = props;
  console.log(ArrayEstadosKeys)
  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Cambiar estado:</DialogTitle>
      <List sx={{ pt: 0 }}>
        {ArrayEstadosKeys[1].map((email) => (
          <ListItem button onClick={() => handleListItemClick(email)} key={email} >
            {/* <ListItemAvatar>
              <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                <PersonIcon />
              </Avatar>
            </ListItemAvatar> */}
            <ListItemText primary={email} />
          </ListItem>
        ))}

        {/* <ListItem autoFocus button onClick={() => handleListItemClick('addAccount')}>
          <ListItemAvatar>
            <Avatar>
              <AddIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary="Add account" />
        </ListItem> */}
      </List>
    </Dialog>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};

export default function SimpleDialogDemo(props) {
  const [open, setOpen] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState(ArrayEstadosKeys[1][props.estadoActual]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);

    const index = ArrayEstadosKeys[1].findIndex(i => i === value);

    setSelectedValue(ArrayEstadosKeys[1][index]);

    props.handleChageState(parseInt(ArrayEstadosKeys[0][index]) , ArrayEstadosKeys[1][index] )
  };

  return (
    <div>
      <Typography variant="subtitle1" component="div">
        Estado: {ArrayEstadosKeys[1][props.estadoActual]}
      </Typography>
      <br />
      <button className="btn btn-ebiex btn-globalhover m-1" onClick={handleClickOpen}>
        Cambiar estado
      </button>
      <SimpleDialog
        selectedValue={selectedValue}
        open={open}
        onClose={handleClose}
      />
    </div>
  );
}
